/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceState = 'ONBOARDED' | 'READY' | 'ASSIGNED' | 'TOMBSTONED';

export const ResourceState = {

    ONBOARDED: 'ONBOARDED' as ResourceState,

    READY: 'READY' as ResourceState,

    ASSIGNED: 'ASSIGNED' as ResourceState,

    TOMBSTONED: 'TOMBSTONED' as ResourceState
};

